import { sortBy } from '@poseidon/shared-utils';
import React from 'react';

import { isNotNull } from '@harmonizeai/poseidon-shared';
import { Button, ButtonGroup, Select } from '@poseidon/components/Input2';
import { Arrows } from '@poseidon/components/StrokeIcons';

type OffsetPaginatorProps = {
  limit?: number;
  defaultLimit: number;
  offset?: number;
  len?: number;
  onChange: (next: { limit?: number; offset?: number }) => void;
};
export const OffsetPaginator = ({ limit, defaultLimit, offset, len, onChange }: OffsetPaginatorProps) => {
  const limitDefined = limit ?? defaultLimit;

  const goNext =
    len == null || len >= limitDefined ? () => onChange({ limit, offset: (offset ?? 0) + limitDefined }) : undefined;
  const goPrev =
    offset != null && offset > 0 ? () => onChange({ limit, offset: Math.max(0, offset - limitDefined) }) : undefined;

  const options = React.useMemo(() => {
    return sortBy(Array.from(new Set([limit, defaultLimit, defaultLimit * 2, defaultLimit * 3].filter(isNotNull)))).map(
      (v) => ({ value: `${v}`, label: `${v}` }),
    );
  }, [limit, defaultLimit]);

  return (
    <ButtonGroup size="sm">
      <Button icon={<Arrows.ArrowLeft />} onClick={goPrev} disabled={goPrev == null} />
      <Select
        className="min-w-16"
        placeholder="limit"
        options={options}
        value={`${limit || defaultLimit}`}
        onChange={(e) => onChange({ limit: Number.parseInt(e.target.value), offset: undefined })}
      />
      <Button icon={<Arrows.ArrowRight />} onClick={goNext} disabled={goNext == null} />
    </ButtonGroup>
  );
};
